import React, { useContext } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Accordion from '@mui/material/Accordion';
import FormControlLabel from '@mui/material/FormControlLabel';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AppContext from '../../context/AppContext';
import MicrowaveIcon from '@mui/icons-material/Microwave';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { pad, range } from '../../utils/Constants';
import randomize from 'randomatic';

const CodeGenerator = () => {
  const { data, setData } = useContext(AppContext);
  const [option, setOption] = React.useState('random');

  const handleChange = (e) => {
    setData({
      ...data,
      auto: { ...data.auto, [e.target.name]: e.target.value },
    });
  };

  const handleGenerate = () => {
    let values = range(
      parseInt(data.auto.start),
      parseInt(data.auto.end),
      parseInt(data.auto.increment),
      parseInt(data.auto.count),
    ).map((value) => {
      let generatedValue = data.auto.padWithZeros
        ? pad(value, data.auto.end.toString().length)
        : value;

      let finalValue = `${data.auto.prefix}${generatedValue}${data.auto.suffix}`;

      return {
        value: finalValue,
      };
    });

    setData({
      ...data,
      items: values,
      text: values.map((valueItem) => valueItem.value).join('\n'),
    });
  };
  const handleGenerateRandom = () => {
    let values = Array.from({ length: data.random.count }, () => {
      let value = randomize('Aa0', data.random.length);
      return {
        value,
      };
    });

    setData({
      ...data,
      items: values,
      text: values.map((valueItem) => valueItem.value).join('\n'),
    });
  };
  return (
    <Accordion sx={{ width: '100%' }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography color="primary" variant="body2">
          <strong>Auto Generate Codes</strong>
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack direction="column" spacing={2}>
          <ToggleButtonGroup
            color="primary"
            value={option}
            exclusive
            onChange={(e, newOption) => setOption(newOption)}
          >
            <ToggleButton value="random">Random</ToggleButton>
            <ToggleButton value="customer">Custom</ToggleButton>
          </ToggleButtonGroup>
          <Stack
            direction={{ xs: 'column', sm: 'column', md: 'row' }}
            spacing={2}
            divider={<Divider orientation="vertical" flexItem />}
          >
            {option.includes('customer') ? (
              <>
                <Stack direction="column" spacing={2}>
                  <Typography color="primary" variant="body2">
                    <strong>1.Choose Numbers</strong>
                  </Typography>
                  <Stack spacing={2} direction="column">
                    <TextField
                      name="start"
                      variant="filled"
                      label="Start"
                      type="number"
                      value={data.auto.start}
                      onChange={handleChange}
                    />
                    <TextField
                      name="end"
                      variant="filled"
                      label="End"
                      type="number"
                      value={data.auto.end}
                      onChange={handleChange}
                    />
                    <TextField
                      name="increment"
                      variant="filled"
                      label="Increment"
                      type="number"
                      value={data.auto.increment}
                      onChange={handleChange}
                    />
                  </Stack>
                </Stack>
                <Stack direction="column" spacing={2}>
                  <Typography color="primary" variant="body2">
                    <strong>2.Add Text</strong>
                  </Typography>
                  <Stack spacing={2} direction="column">
                    <TextField
                      name="prefix"
                      variant="filled"
                      label="Prefix"
                      type="text"
                      placeholder="Text before the number"
                      value={data.auto.prefix}
                      onChange={handleChange}
                    />
                    <TextField
                      name="suffix"
                      variant="filled"
                      label="Suffix"
                      type="text"
                      placeholder="Text after the number"
                      value={data.auto.suffix}
                      onChange={handleChange}
                    />
                    <FormControlLabel
                      label="Pad with Zeros"
                      control={
                        <Checkbox
                          checked={data.auto.padWithZeros}
                          onChange={(e) =>
                            setData({
                              ...data,
                              auto: {
                                ...data.auto,
                                padWithZeros: e.target.checked,
                              },
                            })
                          }
                          inputProps={{ 'aria-label': 'controlled' }}
                        />
                      }
                    />
                  </Stack>
                </Stack>
                <Stack direction="column" spacing={2}>
                  <Typography color="primary" variant="body2">
                    <strong>3.Create the Data</strong>
                  </Typography>
                  <TextField
                    name="count"
                    variant="filled"
                    label="Count"
                    type="number"
                    value={data.auto.count}
                    onChange={handleChange}
                  />
                  <Stack spacing={2} direction="column">
                    <Button
                      onClick={() => handleGenerate()}
                      variant="contained"
                      endIcon={<MicrowaveIcon />}
                    >
                      Generate
                    </Button>
                  </Stack>
                </Stack>
              </>
            ) : (
              <>
                <Stack direction="column" spacing={2}>
                  <Typography color="primary" variant="body2">
                    <strong>1.Random Text</strong>
                  </Typography>
                  <Stack spacing={2} direction="column">
                    <TextField
                      name="length"
                      variant="filled"
                      label="No of Characters"
                      type="text"
                      placeholder="No of Characters"
                      value={data.random.length}
                      onChange={(e) => {
                        setData({
                          ...data,
                          random: {
                            ...data.random,
                            [e.target.name]: e.target.value,
                          },
                        });
                      }}
                    />
                  </Stack>
                </Stack>
                <Stack direction="column" spacing={2}>
                  <Typography color="primary" variant="body2">
                    <strong>2.Create the Data</strong>
                  </Typography>
                  <TextField
                    name="count"
                    variant="filled"
                    label="Count"
                    type="number"
                    value={data.random.count}
                    onChange={(e) => {
                      setData({
                        ...data,
                        random: {
                          ...data.random,
                          [e.target.name]: e.target.value,
                        },
                      });
                    }}
                  />
                  <Stack spacing={2} direction="column">
                    <Button
                      onClick={() => handleGenerateRandom()}
                      variant="contained"
                      endIcon={<MicrowaveIcon />}
                    >
                      Generate
                    </Button>
                  </Stack>
                </Stack>
              </>
            )}
          </Stack>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default CodeGenerator;
